var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2334 61.1C73.2334 62.3 72.9667 63.5333 72.4001 64.7333C71.8334 65.9333 71.1001 67.0666 70.1334 68.1333C68.5001 69.9333 66.7001 71.2333 64.6667 72.0666C62.6667 72.9 60.5001 73.3333 58.1668 73.3333C54.7668 73.3333 51.1334 72.5333 47.3001 70.9C43.4667 69.2666 39.6334 67.0666 35.8334 64.3C32.0001 61.5 28.3667 58.4 24.9001 54.9666C21.4667 51.5 18.3667 47.8666 15.6001 44.0666C12.8667 40.2666 10.6667 36.4666 9.06675 32.7C7.46675 28.9 6.66675 25.2666 6.66675 21.8C6.66675 19.5333 7.06675 17.3666 7.86675 15.3666C8.66675 13.3333 9.93341 11.4666 11.7001 9.79996C13.8334 7.69996 16.1667 6.66663 18.6334 6.66663C19.5667 6.66663 20.5001 6.86663 21.3334 7.26663C22.2001 7.66663 22.9667 8.26663 23.5667 9.13329L31.3001 20.0333C31.9001 20.8666 32.3334 21.6333 32.6334 22.3666C32.9334 23.0666 33.1001 23.7666 33.1001 24.4C33.1001 25.2 32.8668 26 32.4001 26.7666C31.9668 27.5333 31.3334 28.3333 30.5334 29.1333L28.0001 31.7666C27.6334 32.1333 27.4667 32.5666 27.4667 33.1C27.4667 33.3666 27.5001 33.6 27.5668 33.8666C27.6668 34.1333 27.7668 34.3333 27.8334 34.5333C28.4334 35.6333 29.4667 37.0666 30.9334 38.8C32.4334 40.5333 34.0334 42.3 35.7667 44.0666C37.5667 45.8333 39.3001 47.4666 41.0667 48.9666C42.8001 50.4333 44.2334 51.4333 45.3667 52.0333C45.5334 52.1 45.7334 52.2 45.9667 52.3C46.2334 52.4 46.5001 52.4333 46.8001 52.4333C47.3667 52.4333 47.8001 52.2333 48.1667 51.8666L50.7001 49.3666C51.5334 48.5333 52.3334 47.9 53.1001 47.5C53.8668 47.0333 54.6334 46.8 55.4667 46.8C56.1001 46.8 56.7668 46.9333 57.5001 47.2333C58.2334 47.5333 59.0001 47.9666 59.8334 48.5333L70.8668 56.3666C71.7334 56.9666 72.3334 57.6666 72.7001 58.5C73.0334 59.3333 73.2334 60.1666 73.2334 61.1Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 29.9999C61.6667 27.9999 60.1 24.9333 57.7667 22.4333C55.6333 20.1333 52.8 18.3333 50 18.3333",
    stroke: "#276E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 30C73.3333 17.1 62.9 6.66663 50 6.66663",
    stroke: "#276E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCalling);
export default __webpack_public_path__ + "static/media/call-calling.d27c292f1acacd3b6df9c7b7f3c279b0.svg";
export { ForwardRef as ReactComponent };